import React from 'react';

function Footer() {
  return (
    <footer className="bg-gray-800 text-white p-4">
      <div className="container mx-auto text-center">
        <p>&copy; {new Date().getFullYear()} ShopEase. All rights reserved.</p>
        <nav className="space-x-4 mt-2">
          <a href="/contact" className="hover:text-gray-400">Contact Us</a>
          <a href="/privacy" className="hover:text-gray-400">Privacy Policy</a>
          <a href="/help" className="hover:text-gray-400">Help</a>
        </nav>
      </div>
    </footer>
  );
}

export default Footer;
